<template>
  <footer class="text-muted">

    <div class="container">
      <p class="float-right">
        <a href="#" style="font-size: 18px;">回到顶部</a>
      </p>
    </div>

    <div class="container">
      <div class="about fx-sb">
        <div class="info">
          <p style="font-size: 16px">欢迎使用鹰迅公司在线视频课程系统，<b><font color="#0077F6">鹰迅课堂“纳五湖学子，育IT精英”</font></b>，旨在为社会培养更多高水平的计算机专业人才。</p>
          <p style="font-size: 16px">2022年鹰迅公司保留所有权利，备案号：<a href="https://beian.miit.gov.cn/" target="_blank">吉ICP备2022009246号</a></p>
        </div>
        <p></p>
      </div>
    </div>

  </footer>
</template>

<script>

  export default {
    name: 'theFooter',




  }
</script>
